// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__VH-3v","edit-header-wrapper":"style_edit-header-wrapper__NQyBJ","footer-wrapper":"style_footer-wrapper__1o9cH","styled-input":"style_styled-input__FTe+F"};